import { useEffect, useState } from 'react'
import { Query, useQueryClient } from '@tanstack/react-query'
import { isEqual } from 'lodash'

import { getRealTimeQueryKeys } from 'consts/query/query'

const FIND_FRESHEST_QUERY_TIMEOUT = 3_000

export const useDataLastUpdate = () => {
  const queryClient = useQueryClient()
  const [isLoading, setIsLoading] = useState(true)
  const [freshestQuery, setFreshestQuery] = useState<Query>()

  useEffect(() => {
    const unsubscribe = queryClient.getQueryCache().subscribe(cache => {
      const query = cache.query

      if (query.state.status !== 'success') {
        return
      }

      const queryKeyBase = query.queryKey[0]

      const isRealTimeQuery = Boolean(
        queryKeyBase &&
          getRealTimeQueryKeys().some(keyBase => isEqual(keyBase, queryKeyBase)),
      )

      if (!isRealTimeQuery) {
        return
      }
      if (query.state.dataUpdatedAt > (freshestQuery?.state.dataUpdatedAt ?? 0)) {
        setFreshestQuery(query)
        setIsLoading(false)
      }
    })

    return () => {
      unsubscribe()
    }
  }, [queryClient, freshestQuery?.state.dataUpdatedAt])

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (!freshestQuery) {
        setIsLoading(false)
      }
    }, FIND_FRESHEST_QUERY_TIMEOUT)

    return () => {
      clearTimeout(timeoutId)
    }
  }, [freshestQuery])

  return { lastUpdate: freshestQuery?.state.dataUpdatedAt, isLoading }
}
